import { createApp } from 'vue'
// import ProfileMainPage from './components/biobrowser/profile/ProfileMainPage.vue';
import MainPage from '@/views/SpeciesList.vue';
import loadI18n from './i18n'
// createApp(App).mount('#app')
/* eslint-disable no-new */
import VTooltip from 'v-tooltip';
import 'v-tooltip/dist/v-tooltip.css';
const domId = 'species-list-app';

document.addEventListener('DOMContentLoaded', async function () {
  // const body = document.querySelector('body');
  // const year = +body.dataset.year;

  if (document.getElementById(domId)) {
    const app = createApp(MainPage); // , { year });
    app.use(VTooltip);
    const i18n = await loadI18n();
    app.use(i18n);
    app.mount('#' + domId);
  }
});
